import React, { useEffect, useState } from "react";
import MusicTiles from "./MusicTiles";
import Card from "react-bootstrap/esm/Card";
import { makeGetRequest } from "../../../utils/api";
import { urls } from "../../../utils/urls";
import Tabs from "react-bootstrap/esm/Tabs";
import Tab from "react-bootstrap/esm/Tab";

function MusicSelector() {
  const [music, setMusic] = useState([]);
  const [tabList, setTabList] = useState([]);
  const [songs, setSongs] = useState([]);

  const handleMusic = async () => {
    const response = await makeGetRequest(urls.musicSelection, "", true);
    const songList = await makeGetRequest(urls.music_player, "", true);
    setSongs(songList.data);
    setMusic(response.data);
    const setTabs = response.data.map((e) => e.style);
    setTabList([...new Set(setTabs)]);
  };

  useEffect(() => {
    handleMusic();
  }, []);

  return (
    <>
      <Tabs
        defaultActiveKey="GeriActive Favorites"
        id="justify-tab-example"
        className="mb-3"
        justify
        style={{ fontSize: "18px" }}
      >
        {tabList.map((style, x) => {
          return (
            <Tab eventKey={style} title={style} key={style}>
              <Card>
                <MusicTiles
                  key={style}
                  music={music}
                  style={style}
                  songs={songs}
                  x={x}
                />
              </Card>
            </Tab>
          );
        })}
      </Tabs>
    </>
  );
}

export default MusicSelector;
